import * as React from "react";
import type { SVGProps } from "react";
const SvgIcLevelIndicatorFill = (props: SVGProps<SVGSVGElement>) => <svg viewBox="0 0 24 4" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect width={24} height={4} rx={2} fill="currentColor" /></svg>;
export default SvgIcLevelIndicatorFill;